export const formErrors = {
  email: {
    patternMismatch: 'Please enter a valid email address.',
    valueMissing: 'Please enter your email address.',
    typeMismatch: 'Please enter a valid email address.',
  },
};
